<template>
    <v-dialog v-model="alreadyJoin" max-width="446" content-class="white">
        <!-- <v-btn color="#59B6E5" small text icon @click="alreadyJoin = false"><v-icon>mdi-close</v-icon></v-btn> -->
        <v-layout column align-center class="text-center px-16px pt-52px pt-md-100px pt-lg-150px pb-40px">
            <v-img src="/images/event/hunt/icon-warning.svg" class="w-40px w-md-60px mb-20px mb-md-40px md-lg-80px" />
            <h2 class="font-size-18 font-size-md-22 font-size-lg-28 lightblue--text mb-40px mb-md-60px mb-lg-100px">
                오늘은 이미 참여하셨습니다. <br>
                내일 다시 도전해 주세요!
            </h2>
            <v-btn to="/mypage/event" color="#59B6E5" dark class="white--text">마이페이지 바로가기</v-btn>
        </v-layout>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            alreadyJoin: false,
        };
    },
    methods: {
        open() {
            this.alreadyJoin = true;
        },
        close() {
            this.alreadyJoin = false;
        },
    },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_event.scss";

::v-deep{
    .v-dialog{
        border-radius: 24px !important;
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
    ::v-deep{
        .v-dialog{
            border-radius: 52px !important;
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>

